/** Rows that can be opened in the actuals details (HOS) modal. */
export function hosModalNavigableItems(items) {
  return (items || []).filter(item => item && !item._overlap_group_header)
}

export function hosModalItemKey(item, isTbn) {
  if (!item)
    return ''
  if (isTbn)
    return String(item.ID || item.bookingID || '')
  const parts = [item.bookingID, item.movementID].filter(v => v != null && v !== '')
  return parts.join(':')
}

export function findHosModalNavIndex(navItems, currentItem, isTbn) {
  if (!currentItem || !navItems || !navItems.length)
    return -1
  const byRef = navItems.indexOf(currentItem)
  if (byRef >= 0)
    return byRef
  const key = hosModalItemKey(currentItem, isTbn)
  if (!key)
    return -1
  return navItems.findIndex(item => hosModalItemKey(item, isTbn) === key)
}

export function hosModalPageForIndex(index, perPage) {
  if (index < 0 || !perPage)
    return 1
  return Math.floor(index / perPage) + 1
}

export function hosModalNavState(items, currentItem, isTbn) {
  const navItems = hosModalNavigableItems(items)
  const index = findHosModalNavIndex(navItems, currentItem, isTbn)
  const count = navItems.length
  return {
    navItems,
    index,
    count,
    hasPrev: index > 0,
    hasNext: index >= 0 && index < count - 1,
    label: (index >= 0 && count > 1) ? ((index + 1) + ' / ' + count) : '',
  }
}
